import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { Auth, getAuth, onAuthStateChanged, User } from 'firebase/auth';

/** Cached auth state — voorkomt dat elke route-navigatie op Firebase wacht. */
let cachedUser: User | null | undefined = undefined; // undefined = nog niet bepaald
let auth: Auth | null = null;
let listenerSetup = false;

function getAuthLazy(): Auth {
  if (!auth) auth = getAuth();
  return auth;
}

export const authGuard = async () => {
  const router = inject(Router);
  const authInstance = getAuthLazy();
  if (!listenerSetup) {
    listenerSetup = true;
    onAuthStateChanged(authInstance, (user) => {
      cachedUser = user;
    });
  }

  // Als de auth state al bekend is, direct returnen (geen wachttijd)
  if (cachedUser !== undefined) {
    return cachedUser ? true : router.parseUrl('/login');
  }

  // Alleen bij eerste load wachten op Firebase
  return new Promise<any>((resolve) => {
    const unsubscribe = onAuthStateChanged(authInstance, (user) => {
      unsubscribe();
      cachedUser = user;
      resolve(user ? true : router.parseUrl('/login'));
    });
  });
};
